var _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_126_667",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 15,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3335 1.82715H17.4725V18.7901H3.3335V1.82715Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_126_667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.403 3.07715C9.69634 3.07715 5.23801 4.64715 4.72384 5.07631C4.57217 5.22882 4.56634 5.49381 4.59884 7.26798C4.61384 8.12298 4.63467 9.28465 4.63467 10.893C4.63467 15.2271 9.40301 17.1513 10.4022 17.5055C11.4005 17.1496 16.1713 15.2146 16.1713 10.893C16.1713 9.28298 16.1922 8.12048 16.208 7.26548C16.2397 5.49298 16.2338 5.22798 16.073 5.06798C15.5688 4.64715 11.1097 3.07715 10.403 3.07715ZM10.403 18.7905C10.3422 18.7905 10.2813 18.7821 10.2222 18.7638C9.94301 18.6796 3.38467 16.628 3.38467 10.893C3.38467 9.29548 3.36384 8.13965 3.34884 7.29132C3.31051 5.17215 3.30217 4.73048 3.84967 4.18382C4.50384 3.52798 9.45801 1.82715 10.403 1.82715C11.3472 1.82715 16.3013 3.52798 16.9572 4.18382C17.5038 4.73048 17.4955 5.17215 17.4572 7.28882C17.4422 8.13715 17.4213 9.29298 17.4213 10.893C17.4213 16.628 10.863 18.6796 10.5838 18.7638C10.5247 18.7821 10.4638 18.7905 10.403 18.7905Z",
    fill: "#98BCD6"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81436 12.2605C9.64852 12.2605 9.48936 12.1947 9.37186 12.0772L7.79519 10.4989C7.55186 10.2547 7.55186 9.85803 7.79602 9.6147C8.03936 9.37053 8.43602 9.37053 8.68019 9.6147L9.81436 10.7505L12.621 7.94387C12.8652 7.6997 13.2602 7.6997 13.5044 7.94387C13.7485 8.18803 13.7485 8.58387 13.5044 8.82803L10.256 12.0772C10.1394 12.1947 9.98019 12.2605 9.81436 12.2605Z",
    fill: "#98BCD6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.7289d4b5210c901b85dd84e379c77e16.svg";
export { ForwardRef as ReactComponent };